import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { BlogPost, BlogList, BlogCount } from '../blog-interface';
import { Observable } from 'rxjs';
import { ByEmployee } from '../../skill-matrix/api-interfaces';
import { publishReplay, refCount } from 'rxjs/operators';
@Injectable()
export class BlogService {
public editData;
public quarterStart;
public quarterEnd;
employeeName: Observable<Object>
  constructor(private http: HttpClient) { }

  private getHeaders() {
    return new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'access-token': localStorage.getItem('access-token'),
      'client': localStorage.getItem('client'),
      'client_id': localStorage.getItem('client_id'),
      'uid': localStorage.getItem('uid')
    });
  }
  // admin blog operations
  blogPost(newBlog): Observable<BlogPost>{
    const requestUrl = `${environment.blog_url}admin/blogs`;
    const headers = this.getHeaders();
    return this.http.post<BlogPost>(requestUrl, newBlog, { headers: headers })
  }
  getBlogList(startDate?, endDate?, type?, page?, limit?, empId?, sortby?, orderby?): Observable<BlogList[]>{
    const requestUrl = `${environment.blog_url}admin/blogs?`;
    let params = (startDate) ? `start_date=${startDate}`: '';
    params += (endDate) ? `&end_date=${endDate}`: '';
    params += (type) ? `&type=${type}`: '';
    params += (page) ? `&page= ${page}`: '&page=1';
    params += (limit) ? `&limit= ${limit}`: '';
    params += (empId) ? `&emp_id=${empId}`: '';
    params += (sortby) ? `&sortBy=${sortby}`: '';
    params += (orderby) ? `&orderBy=${orderby}`: '';
    // const requestUrl = `${environment.blog_url}admin/blogs?start_date=${startDate}&end_date=${endDate}&type=${type}&page=${page}&limit=${limit}&emp_id=${empId}&sortBy=${sortby}&orderBy=${orderby}`;
    const headers = this.getHeaders();
    return this.http.get<BlogList[]>(requestUrl + params, { headers: headers })
  }
  editBlog(data, id): Observable<BlogList[]>{
    const requestUrl = `${environment.blog_url}admin/blogs/` + id;
    const headers = this.getHeaders();
    return this.http.patch<BlogList[]>(requestUrl,data, { headers: headers })
  }
  deleteBlog(id){
    const requestUrl = `${environment.blog_url}admin/blogs/` + id;
    const headers = this.getHeaders();
    return this.http.delete<BlogPost>(requestUrl, { headers: headers })
  }
  // get employee name from other service
  getEmployeeFromService(): Observable<any> {    
    const head = new HttpHeaders({
      'Content-Type': 'application/json',
        'Accept': 'application/json',
        'access-token': localStorage.getItem('access-token'),
        'client': localStorage.getItem('client'),
        'uid': localStorage.getItem('uid')
      });
    if (!this.employeeName) {
      const headers = head;
      const requestUrl = `${environment.skill_matrix_api}user`;
      return this.employeeName = this.http.get(requestUrl, { headers: headers })
      .pipe(publishReplay(1), refCount());
    }
    return this.employeeName;
  }
  // User List
  getUserBlogList(startDate?, endDate?, type?, page?, limit?, sortby?, orderby?): Observable<BlogList[]> {
    const requestUrl = `${environment.blog_url}blogs?`;
    let params = (startDate) ? `start_date=${startDate}`: '';
    params += (endDate) ? `&end_date=${endDate}`: '';
    params += (type) ? `&type=${type}`: '';
    params += (page) ? `&page= ${page}`: '&page=1';
    params += (limit) ? `&limit= ${limit}`: '';
    params += (sortby) ? `&sortBy=${sortby}`: '';
    params += (orderby) ? `&orderBy=${orderby}`: '';
    const headers = this.getHeaders();
    return this.http.get<BlogList[]>(requestUrl + params, { headers: headers })
  }
  // search filter for admin
  searchById(id): Observable<BlogList[]> {
    const requestUrl = `${environment.blog_url}admin/blogs/`+ id;
    const headers = this.getHeaders();
    return this.http.get<BlogList[]>(requestUrl, { headers: headers })
  }
  // search filter for user
  userSearchById(id): Observable<BlogList[]>{
    const requestUrl = `${environment.blog_url}blogs/`+ id;
    const headers = this.getHeaders();
    return this.http.get<BlogList[]>(requestUrl, { headers: headers })
  }
  // blog count for user 
  getBlogCount(startDate?, endDate?, type?): Observable<BlogCount>{
    const requestUrl = `${environment.blog_url}blogs/count?`;
    let params = (startDate) ? `start_date=${startDate}`: '';
    params += (endDate) ? `&end_date=${endDate}`: '';
    params += (type) ? `&type=${type}`: '';
    const headers = this.getHeaders();
    return this.http.get<BlogCount>(requestUrl + params, { headers: headers })
  }
}



// WEBPACK FOOTER //
// /home/bharath/agira-projects/asmart/agira-intranet-ui/src/app/blog/services/blog.service.ts